import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, inject } from '@angular/core';
import {Ad, PriceType} from "../../interfaces/ad";
import {CreateChat} from "../../interfaces/chat";
import {ApiService} from "../../services/api.service";
import {getDummyPicture} from "../../utils/dummyImages";
import {AuthenticationService} from "../../services/auth.service";
import {User} from "../../interfaces/user";
import {CipherType} from "../../interfaces/cipher";
import {ToastService} from "../../services/toast.service";
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { ImageSourcePipe } from '../../pipes/image-source.pipe';

@Component({
    selector: 'kaz-fast-message',
    templateUrl: './kaz-fast-message.component.html',
    styleUrls: ['./kaz-fast-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, FaIconComponent, FormsModule, CurrencyPipe, ImageSourcePipe]
})
export class KazFastMessageComponent {
  private _api = inject(ApiService);
  private _toast = inject(ToastService);
  private _auth = inject(AuthenticationService);

  @Input() ad: Ad | null = null;
  @Output() closeFastMessageOnEmit = new EventEmitter();

  chat: CreateChat | null = null;
  message: string = "";

  sendContactData: boolean = false;

  ownUser: User | null = null;

  closeFastMessage() {
    this.closeFastMessageOnEmit.emit();
  }

  async createMessage() {
    try {
      const claims = this._auth.getClaimsFromToken();
      if (this.ad !== null && claims !== null) {

        this.ownUser = await this._api.getOwnUser(claims.id);
        if (this.sendContactData) {
          this.message += "\n\nInformationen über Interessent:\n";
          this.message += this.ownUser.firstname + " " + this.ownUser.lastname + "\n";
          // this.message += this.ownUser.phone + "\n";
          this.message += this.ownUser.mail;
        }

        this.chat = {
          recipientId: this.ad.authorId,
          adId: this.ad.id,
          message: this.message
        }
        await this._api.createChat(this.chat);
        this._toast.showToast(null, "Nachricht erfolgreich versendet 🥳");
        this.closeFastMessage();
      }
    } catch (err) {
      console.log(err);
    }
  }

  protected readonly getDummyPicture = getDummyPicture;
  protected readonly PriceType = PriceType;
  protected readonly CipherType = CipherType;
}
